import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TabVisibilityService {
  private isTabVisibleSubject = new BehaviorSubject<boolean>(!document.hidden);
  public isTabVisible$ = this.isTabVisibleSubject.asObservable();

  private visibilityChangeHandler = (): void => {
    this.isTabVisibleSubject.next(!document.hidden);
  };

  public startTabVisibilityListener(): void {
    document.addEventListener('visibilitychange', this.visibilityChangeHandler);
  }

  public stopTabVisibilityListener(): void {
    document.removeEventListener(
      'visibilitychange',
      this.visibilityChangeHandler,
    );
  }
}
